/* eslint-disable camelcase */
/* eslint-disable react/jsx-indent */
import React, { useMemo } from 'react'
import { Menu, Icon } from 'antd'
import { withRouter } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  getPermitActions,
  getEnvConfig,
  getUserInfo,
  getApiTargetInfo,
} from 'core/selectors'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { logout } from './Dashboard'
import { Filler } from 'core/screen-util'
import { getKpiSpec, getContribKeys, getCAContribKeys } from 'outage-analysis'
import { foreCastMetrics } from 'outage-analysis/utils'
import { MarginAnalysisMenu } from './marginanalysis'
// import { AEPAcaSppReportSideNav } from './aep/aca-spp-report/index.js'

import {
  APS_CLIENT,
  BROOKFIELD_CLIENT,
  NE_NEW_ENGLAND,
  PJM_CLIENT,
  MISO_CLIENT,
  KINDLE_CLIENT,
  TALEN_CLIENT,
  EAST_GEN_CLIENT,
  NRG_CLIENT,
  TOTALENGERY_CLIENT,
  NYISO_CLIENT,
  COOP_CLIENT,
  BEPC_CLIENT,
} from './client'

import { PjmAdminMenu, PjmAdminOutageMenu } from './pjmadmin'
import NeISOMenu from 'menuclient/NEISO'
import NYISOMenu from 'menuclient/NYISO'
import { TPSMenu } from 'admin/tps'
import { SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN } from './core/EventActions'
import { FilterContext } from 'context'
import { emptyFilterObj } from './context/FilterContext'

const SubMenu = Menu.SubMenu

const UserNav = ({
  onSelect,
  menuTheme = 'dark',
  currentPath,
  actionPermits,
  envConfig,
  userInfo,
  kpiSpec,
  // contribKeys,
  // caContribKeys,
  apiTargetInfo,
  setFilterDrawerVisible,
  setGridProps,
  setFilterCondition,
}) => {
  const { authGodMode, isStackTraceAllowed = true } = envConfig

  const CLIENT = envConfig.clientId || 'INTEG'

  const hasGraphAccess = useMemo(
    _ =>
      authGodMode ||
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.GRAPH_MW,
          ScreenPermissions.GRAPH_COMMERCIAL,
          ScreenPermissions.GRAPH_FORECAST,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hasSwitchboardAccess = useMemo(
    _ =>
      authGodMode ||
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.SWITCHBOARD,
          ScreenPermissions.SWITCHBOARD_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hasGraphForecastsAccess = useMemo(
    _ =>
      authGodMode ||
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.GRAPH_FORECAST],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hasGraphMWAndCommercialAccess = useMemo(
    _ =>
      authGodMode ||
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.GRAPH_MW,
          ScreenPermissions.GRAPH_COMMERCIAL,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hasAdminPermission = useMemo(
    _ => {
      const adminMenu =
        authGodMode ||
        hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [
            ScreenPermissions.IT_REGISTRATION,
            ScreenPermissions.CHANGE_PERMISSIONS,
            ScreenPermissions.ACCESS_PERMISSIONS,
          ],
          matchAny: true,
        })
      return adminMenu
    },
    [actionPermits, authGodMode]
  )

  const hasWebServiceAccessPermission = useMemo(
    _ => {
      const adminMenu =
        authGodMode ||
        hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [ScreenPermissions.WEBSERVICE_ACCESS_PERMISSIONS],
          matchAny: true,
        })
      return adminMenu
    },
    [actionPermits, authGodMode]
  )

  const hasNYISOIIFOPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NYISO_IIFO],
      }),
    [actionPermits, authGodMode]
  )
  const hasNYISOMarsParameterPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NYISO_MARS_PARAMETERS],
      }),
    [actionPermits, authGodMode]
  )

  const hasNYISOPLWPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NYISO_PLW],
      }),
    [actionPermits, authGodMode]
  )

  const hasNYISOSupportDataPermission =
    hasNYISOIIFOPermission ||
    hasNYISOPLWPermission ||
    hasNYISOMarsParameterPermission

  const hasPerValidationMonthly = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.VALIDATION_MONTHLY],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hasPerValidationBlockLevel2 = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.VALIDATION_BLOCK_LEVEL_2_PROCESSING],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hasWindPowerData = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.WIND_POWER_DATA,
          ScreenPermissions.WIND_ADMIN_POWER_DATA,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )
  const hasWindPowerData20 = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.WIND_POWER_DATA_20,
          ScreenPermissions.WIND_ADMIN_POWER_DATA_20,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hideWind2TurbinePerformance = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.HIDE_WIND2_TURBINE_PERFORMANCE],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hasSolarPowerData20 = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.SOLAR_POWER_DATA,
          ScreenPermissions.SOLAR_ADMIN_POWER_DATA,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hideSolarInverterData = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.HIDE_SOLAR_INVERTER_DATA],
        matchAny: true,
      }),
    [actionPermits]
  )

  const showSolarStorageData = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SHOW_SOLAR_STORAGE_DATA],
        matchAny: true,
      }),
    [actionPermits]
  )

  const showSolarStorageStandaloneData = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [
          ScreenPermissions.SHOW_SOLAR_STORAGE_STANDALONE_DATA,
          SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hasSolarPIMissingData = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_PI_MISSING_DATA],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const solarPiImportIntervals = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_PI_IMPORT_INTERVALS],
        matchAny: true,
      }),
    [actionPermits]
  )
  const wind2PiImportIntervals = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_PI_IMPORT_INTERVALS],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hasWindAdhoc = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_ADHOC_MATRIX_REPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const hasWindReort20 = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_REPORT_20],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasWind2PIRowdata = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_PI_ROW_DATA_READ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasEventDashboardReport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.EVENT_DASHBOARD],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasSRPEventDashboardReport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SRP_EVENT_DASHBOARD],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const windAdminScreenAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_ADMIN_SCRREEN_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const wind20AdminScreenAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_ADMIN_SCRREEN_PERMISSIONS_20],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const solarAdminScreenAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_ADMIN_SCRREEN_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const OperatingData = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.OPERATING_DATA],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasPiAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.PI_READ_TAG_MANAGEMENT,
          ScreenPermissions.PI_WRITE_TAG_MANAGEMENT,
          ScreenPermissions.PI_DATA_IMPORT,
          ScreenPermissions.PI_DATA,
          ScreenPermissions.PI_READ_MONTHLY_SUMMARY,
          ScreenPermissions.PI_WRITE_MONTHLY_SUMMARY,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasPiImportDataAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.PI_DATA,
          ScreenPermissions.PI_DATA_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const hasPiTagManagementAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.PI_READ_TAG_MANAGEMENT,
          ScreenPermissions.PI_WRITE_TAG_MANAGEMENT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasPiMonthlySummaryAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.PI_READ_MONTHLY_SUMMARY,
          ScreenPermissions.PI_WRITE_MONTHLY_SUMMARY,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasSchedulerPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SCHEDULER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasMonthlyPerfDataPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MONTHLY_PERF_DATA,
          ScreenPermissions.MONTHLY_PERF_DATA_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const marginAnalysisAdminPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MARGIN_ANALYSIS_ADMIN,
          ScreenPermissions.MARGIN_ANALYSIS_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const marginAnalysisEventPlanning = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_EVENT_PLANNER_SCREEN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const marginAnalysisSummary = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_SUMMARY],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const marginAnalysisTrueup = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_TRUEUP],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const marginAnalysisPJMImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_PJMIMPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  // const marginAnalysisPromod = useMemo(
  //   _ =>
  //     hasAccesPermits({
  //       authGodMode: envConfig.authGodMode,
  //       actionPermits,
  //       eventActions: [ScreenPermissions.MARGIN_ANALYSIS_PROMOD],
  //       matchAny: true,
  //     }),
  //   [actionPermits, envConfig.authGodMode]
  // )

  const marginAnalysisDataPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MARGIN_ANALYSIS_CORE_WRITE,
          ScreenPermissions.MARGIN_ANALYSIS_CORE_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceCraneCreek = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CRANECREEK_IMPORT_ADMIN,
          ScreenPermissions.CRANECREEK_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceForwardImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.FORWARD_IMPORT_ADMIN,
          ScreenPermissions.FORWARD_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceBSGF = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.BSGF_IMPORT_ADMIN,
          ScreenPermissions.BSGF_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceGHWP = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.GHWP_IMPORT_VIEWER,
          ScreenPermissions.GHWP_IMPORT_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceTurbinePoints = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.TURBINE_POINTS_IMPORT_ADMIN,
          ScreenPermissions.TURBINE_POINTS_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceBSGFErrorCodeMap = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.BSGF_GHWP_ERROR_MAP_IMPORT_ADMIN,
          ScreenPermissions.BSGF_GHWP_ERROR_MAP_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceMW = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MW_IMPORT_ADMIN,
          ScreenPermissions.MW_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceBreakerImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.BREAKER_IMPORT_ADMIN,
          ScreenPermissions.BREAKER_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const performanceOveride = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.REPORT_PERFORMANCE_MEASURES_ADMIN,
          ScreenPermissions.REPORT_PERFORMANCE_MEASURES_VIEW,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const tpsMappingAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.TPS_MAPPING_READ,
          ScreenPermissions.TPS_MAPPING_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const tpsMaDataImportAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.TPS_MA_DATA_IMPORT],
        matchAny: true,
      }),
    [actionPermits]
  )
  const misoMaDataImportAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.MISO_MA_DATA_IMPORT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const tpsDataAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.TPS_DATA_READ,
          ScreenPermissions.TPS_DATA_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const kindleMySqqlDALmp = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_DA_LMP,
          ScreenPermissions.KINDLE_MYSQL_DA_LMP_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const kindleMySqqlRTLmp = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_RT_LMP,
          ScreenPermissions.KINDLE_MYSQL_RT_LMP_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const kindleMySqqlGeneration = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_GENERATION_READ,
          ScreenPermissions.KINDLE_MYSQL_GENERATION_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const kindleMySqqlDaAward = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_DA_AWARD_ADMIN,
          ScreenPermissions.KINDLE_MYSQL_DA_AWARD_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const kindleMySqqlFuel = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_FUEL_ADMIN,
          ScreenPermissions.KINDLE_MYSQL_FUEL_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const kindleMySqqlMenu = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_FUEL_ADMIN,
          ScreenPermissions.KINDLE_MYSQL_FUEL_READ,
          ScreenPermissions.KINDLE_MYSQL_DA_AWARD_ADMIN,
          ScreenPermissions.KINDLE_MYSQL_DA_AWARD_READ,
          ScreenPermissions.KINDLE_MYSQL_DA_LMP,
          ScreenPermissions.KINDLE_MYSQL_DA_LMP_ADMIN,
          ScreenPermissions.KINDLE_MYSQL_RT_LMP,
          ScreenPermissions.KINDLE_MYSQL_RT_LMP_ADMIN,
          ScreenPermissions.KINDLE_MYSQL_GENERATION_ADMIN,
          ScreenPermissions.KINDLE_MYSQL_GENERATION_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hidePercentOwnership = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.HIDE_PERCENT_OWNERSHIP],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const showOaPnodeZoneScreen = useMemo(
    _ =>
      !hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.OA_PNODE_ZONE_HIDE],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const aepACAPSPPReport = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.AEP_ACA_SPP_DATA_READ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const eventHydro = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.HYDRO_VIEW,
          ScreenPermissions.HYDRO_ADD_DATA,
          ScreenPermissions.HYDRO_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const processHydro = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.HYDRO_PROCESS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const renameHydroToBreakerEvent = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.RENAME_HYDRO_TO_BREAKER_EVENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const srpSystemCodeManagementAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SYSTEM_CODE_MANAGEMENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const unitExtensionAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.UNIT_EXTENSION_MANAGEMENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const universalId = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.UNIVERSAL_ID],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const riverSystemUnit = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.RIVER_SYSTEM_UNIT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const riverSystemRegion = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.RIVER_SYSTEM_REGIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const nonHydroEvent = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NONHYDRO_VIEW,
          ScreenPermissions.NONHYDRO_ADD_DATA,
          ScreenPermissions.NONHYDRO_IMPORT,
          ScreenPermissions.NONHYDRO_PROCESS,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const nonOutageSpill = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NON_OUTAGE_SPILL_READ,
          ScreenPermissions.NON_OUTAGE_SPILL_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const melComponent = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MEL_COMPONENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hideNercCapacity = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.HIDE_NERC_CAPACITY],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hideNercGroup = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.HIDE_NERC_GROUP],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const melCausecode = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MEL_CAUSECODE],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const ctInspection = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CT_INSPECTION_ADMIN,
          ScreenPermissions.CT_INSPECTION_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasBidOffer = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.BID_OFFER_READ,
          ScreenPermissions.BID_OFFER_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasScheduleDetail = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.SCHEDULE_DETAIL_READ,
          ScreenPermissions.SCHEDULE_DETAIL_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasOpThreshold = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.OP_THRESHOLD_READ,
          ScreenPermissions.OP_THRESHOLD_WRITE,
          ScreenPermissions.OP_THRESHOLD_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const hasOutageAnalysis = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.OUTAGE_ANALYZER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasOutageAnalysisMenu =
    hasBidOffer || hasScheduleDetail || hasOpThreshold || hasOutageAnalysis

  const hasOutageAnalysisDaLmp = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.DALMP_READ,
          ScreenPermissions.DALMP_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasOutageAnalysisRtLmp = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.RTLMP_READ,
          ScreenPermissions.RTLMP_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const netCapacityVerificationRead = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NET_CAP_VERIFICATION,
          ScreenPermissions.NET_CAP_VERIFICATION_WRITE,
          ScreenPermissions.NET_CAP_VERIFICATION_IMPORT,
          ScreenPermissions.NET_CAP_VERIFICATION_EXPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const netCapacityVerificationWrite = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NET_CAP_VERIFICATION_WRITE,
          ScreenPermissions.NET_CAP_VERIFICATION_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const netCapacityVerificationImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NET_CAP_VERIFICATION_IMPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const netCapacityVerificationExport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NET_CAP_VERIFICATION_EXPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const VerificationHourlyMWH = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.VERIFICATION_HOURLY_MWH],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const eventPending = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.VALIDATION_EVENT_PENDING,
          ScreenPermissions.VALIDATION_EVENT_PENDING_APPROVAL,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const apsPiWs = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.APS_PI_ENTITY],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const piTagAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.PITAG_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const solarDaysCreationAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_DAYS_CREATION],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const errorTraceAdminScreen = useMemo(
    _ =>
      !isStackTraceAllowed &&
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.ERROR_LOG_SCREEN_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode, isStackTraceAllowed]
  )

  const errorTraceUserScreen = useMemo(
    _ =>
      !isStackTraceAllowed &&
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.ERROR_LOG_SCREEN_USER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode, isStackTraceAllowed]
  )

  const showNercClassAvgEford = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NERC_CLASS_AVG_EFORD],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const misoAdminTestDuration = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_MIN_TEST_DURATION],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const profitcost = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.PROFIT_COST],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const nrgEventReportSpec = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NRG_EVENT_REPORT_SPEC],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const showUnitBlock = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.UNIT_BLOCK],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const misoAdminTestDefault = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_TEST_DEFAULT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const misoAdminVerificationSeason = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_VERIFICATION_SEASON],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const verificationLock = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.VERIFICATION_LOCK],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const nyisoderateGroup = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NYISO_DERATE_GROUP],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const hasAdminPeackDefinitation = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.PEAK_DEFINITATION],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasAdminPeackDefinitationHoliday = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.PEAK_DEF_HOLIDAY],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const MisoVerificationTestData = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MISO_NET_CAP_VERIFICATION,
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_WRITE,
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_IMPORT,
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_EXPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const MisoNetCapacityVerificationWrite = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_WRITE,
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const ContribConditionView = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CONTRIB_CONDITION],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const MisoNetCapacityVerificationImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_NET_CAP_VERIFICATION_IMPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const MisoNetCapacityVerificationExport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_NET_CAP_VERIFICATION_EXPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const UserMessageAccessTools = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.TALEN_USER_MESSAGE],
        matchAny: false,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hideCauseCodeLookUp = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.HIDE_CAUSE_CODE_LOOKUP],
        matchAny: false,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hideEventDurationCalculator = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.HIDE_EVENT_DURATION_CALCULATOR],
        matchAny: false,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const UserMessageAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.TALEN_USER_MESSAGE,
          ScreenPermissions.CHANGE_PERMISSIONS,
        ],
        matchAny: false,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const UserMessageCategoryAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.TALEN_USER_MESSAGE_CATEGORY,
          ScreenPermissions.CHANGE_PERMISSIONS,
        ],
        matchAny: false,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const MessageCategoryAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.TALEN_MESSAGE_CATEGORY,
          ScreenPermissions.CHANGE_PERMISSIONS,
        ],
        matchAny: false,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const tpsUnitMappingAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [
          ScreenPermissions.TPS_UNIT_MAPPING_READ,
          ScreenPermissions.TPS_UNIT_MAPPING_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const misoUnitMappingAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [
          ScreenPermissions.MISO_UNIT_MAPPING_READ,
          ScreenPermissions.MISO_UNIT_MAPPING_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const pprAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.PPR_EXPORT],
        matchAny: true,
      }),
    [actionPermits]
  )
  const tpsFileLogAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.TPS_FILE_LOG],
        matchAny: true,
      }),
    [actionPermits]
  )

  const wind2ImportCSV = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND_IMPORT_CSV_20],
        matchAny: true,
      }),
    [actionPermits]
  )

  const unitPerformanceGroup = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.UNIT_PERFORMANCE_GROUP],
        matchAny: true,
      }),
    [actionPermits]
  )

  const nrgCard95DataAnalyticsImport = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.NRG_DATA_ANALYTICS_IMPORT_CARD95],
        matchAny: true,
      }),
    [actionPermits]
  )

  const nrgCard97DataAnalyticsImport = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.NRG_DATA_ANALYTICS_IMPORT_CARD97],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarMenuOnly = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_SCREEN_MENU_SHOW_ONLY],
        matchAny: true,
      }),
    [actionPermits]
  )

  const wind20MenuOnly = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND20_SCREEN_MENU_SHOW_ONLY],
        matchAny: true,
      }),
    [actionPermits]
  )

  const wind2FileCreation = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_FILE_CREATION],
        matchAny: true,
      }),
    [actionPermits]
  )

  const wind2FileImport = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_FILE_IMPORT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hasWind2PIMissingData = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_PI_MISSING_DATA],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const solarFileCreation = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_FILE_CREATION],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarFileImport = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_FILE_IMPORT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarFileImportCSV = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_FILE_IMPORT_CSV],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarReportAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_REPORT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarLsbpSFEVentMeasuemrnt = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.LSBP_SF_EVENT_MEASURMENT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hasSolarPIRowdata = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_PI_ROW_DATA_READ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const wsGenerationMW = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WS_GENERATION_MW],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const wsBreakerData = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WS_BREAKER_DATA],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const wsFuelCost = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WS_FUELCOST],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const SolarGenerationDataRead = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.SOLAR_GENERATION_DATA_READ,
          ScreenPermissions.SOLAR_GENERATION_DATA_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const wsMarketPrice = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WS_MARKET_PRICE],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const solarPlantExtraInfo = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_PLANT_EXTRA_INFO],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasTalenOutageAnalysisMenu =
    hasBidOffer ||
    hasScheduleDetail ||
    hasOutageAnalysisDaLmp ||
    hasOutageAnalysisRtLmp ||
    hasOutageAnalysis

  const hasWsInterfaceMenu =
    wsGenerationMW || wsFuelCost || wsFuelCost || wsMarketPrice

  const hasTpsInterfaceMenu =
    tpsUnitMappingAccess || tpsFileLogAccess || tpsMaDataImportAccess
  const hasMisoInterfaceMenu = misoUnitMappingAccess || misoMaDataImportAccess

  const verificationMenu =
    netCapacityVerificationRead ||
    netCapacityVerificationWrite ||
    netCapacityVerificationImport ||
    netCapacityVerificationExport ||
    VerificationHourlyMWH

  const hasInterfaceMenu =
    hasInterfaceBreakerImport ||
    hasInterfaceMW ||
    hasInterfaceCraneCreek ||
    hasInterfaceForwardImport ||
    hasInterfaceBSGF ||
    hasInterfaceGHWP ||
    hasInterfaceTurbinePoints ||
    hasInterfaceBSGFErrorCodeMap

  const misoAdminMenu =
    misoAdminTestDefault || misoAdminTestDuration || misoAdminVerificationSeason

  const SolarAdminMenu = solarAdminScreenAccess && (
    <SubMenu
      title={
        !solarMenuOnly ? (
          'Solar Management'
        ) : (
          <>
            {' '}
            <span>
              <Icon
                type="alert"
                style={{
                  height: '64px',
                  lineHeight: '64px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                }}
              />
              Solar Management
            </span>
          </>
        )
      }
    >
      <Menu.Item key="solar/plants">Solar Plants</Menu.Item>
      {piTagAccess && (
        <Menu.Item exact key="admin/pi-tag">
          PI Tag
        </Menu.Item>
      )}
      <Menu.Item key="solar/inverter-group">Inverter Group</Menu.Item>
      <Menu.Item key="solar/inverter-group-formation">
        Inverter Formation
      </Menu.Item>

      <Menu.Item key="solar/user-acces-right">User Access Right</Menu.Item>
      <SubMenu title="Solar Support Data">
        <Menu.Item key="solar/entity">Solar Entity</Menu.Item>
        {solarDaysCreationAccess && (
          <Menu.Item key="solar/days-creation">Solar Days Creation</Menu.Item>
        )}
        {solarPlantExtraInfo && (
          <Menu.Item key="solar/plants-extra-info">
            Solar Plants Extra Info
          </Menu.Item>
        )}
        <Menu.Item key="solar/inverter-manufacturer">
          Inverter Manufacturer
        </Menu.Item>
        <Menu.Item key="solar/scada-manufacturer">SCADA Manufacturer</Menu.Item>
        <Menu.Item key="solar/storage-group">Storage Group</Menu.Item>
        <Menu.Item key="solar/storage-group-formation">
          Storage Group formation
        </Menu.Item>
        <Menu.Item key="solar/storage-inverter-manufacturer">
          Storage Inverter Manufacturer
        </Menu.Item>
        <Menu.Item key="solar/storage-manufacturer">
          Storage Manufacturer
        </Menu.Item>
        <Menu.Item key="solar/causecode">Cause Code</Menu.Item>
        <Menu.Item key="solar/errors">Solar Error Codes Managament</Menu.Item>
        <Menu.Item key="solar/lockcheck">Solar Lock Management</Menu.Item>
      </SubMenu>
    </SubMenu>
  )
  const hassolarDataPermission =
    hasSolarPowerData20 ||
    showSolarStorageData ||
    showSolarStorageStandaloneData ||
    solarReportAccess ||
    hasSolarPIRowdata

  const SolarMenu = hassolarDataPermission && (
    <SubMenu
      title={
        !solarMenuOnly ? (
          'Solar'
        ) : (
          <>
            <span>
              <Icon
                type="alert"
                style={{
                  height: '64px',
                  lineHeight: '64px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                }}
              />
              Solar
            </span>
          </>
        )
      }
    >
      {hasSolarPowerData20 && (
        <Menu.Item key="solar/solar-power-data">Solar Data</Menu.Item>
      )}
      {hasSolarPowerData20 && !hideSolarInverterData && (
        <Menu.Item key="solar/solar-inverter-perf-data">
          Solar Inverter Data
        </Menu.Item>
      )}
      {showSolarStorageData && (
        <Menu.Item key="solar/solar-storage-data">Solar Storage Data</Menu.Item>
      )}
      {showSolarStorageStandaloneData && (
        <Menu.Item key="solar/solar-storage-standalone-data">
          Solar Standalone Storage Data
        </Menu.Item>
      )}

      {/* <Menu.Item key="solar/solar-power-data">Solar Data</Menu.Item>,
      <Menu.Item key="solar/solar-inverter-perf-data">
        Solar Inverter Data
      </Menu.Item> */}
      {SolarGenerationDataRead && (
        <Menu.Item key="solar/solar-generation-data">
          Solar Generation Data
        </Menu.Item>
      )}
      {hasSolarPowerData20 && (
        <Menu.Item key="solar/solar-level2-validation">
          Solar Level 2 Validation
        </Menu.Item>
      )}
      {solarPiImportIntervals && (
        <Menu.Item key="solar/solar-pi-import-intervals">
          Solar PI Import Intervals
        </Menu.Item>
      )}
      {hasSolarPIMissingData && (
        <Menu.Item key="solar/solar-missing-data">
          Solar PI Missing Data
        </Menu.Item>
      )}
      {solarFileCreation && (
        <Menu.Item key="solar/solar-file-creation">
          Solar NERC File Creation
        </Menu.Item>
      )}
      {solarFileImport && (
        <Menu.Item key="solar/solar-nerc-file-import">
          Solar NERC File Import
        </Menu.Item>
      )}
      {solarFileImportCSV && (
        <Menu.Item key="solar/solar-file-inv-import">
          Solar Inverter File Import
        </Menu.Item>
      )}
      {solarReportAccess && (
        <Menu.Item key="solar/solar-report">Solar Report</Menu.Item>
      )}
      {solarLsbpSFEVentMeasuemrnt && [
        <Menu.Item key="solar/solar-lsbp-event">SF Events</Menu.Item>,
        <Menu.Item key="solar/solar-lsbp-measurment">SF Measurment</Menu.Item>,
      ]}
      {hasSolarPIRowdata && (
        <SubMenu title="PI Row Data">
          <Menu.Item key="solar/pi-row-10min-data">10Min Data</Menu.Item>
          <Menu.Item key="solar/pi-row-hourly-data">Hourly Data</Menu.Item>
          <Menu.Item key="solar/pi-row-daily-data">Daily Data</Menu.Item>
        </SubMenu>
      )}
    </SubMenu>
  )

  const Wind20AdminMenu = wind20AdminScreenAccess && (
    <SubMenu
      title={
        !wind20MenuOnly ? (
          'Wind Management 2.0'
        ) : (
          <>
            {' '}
            <span>
              <Icon
                type="thunderbolt"
                style={{
                  height: '64px',
                  lineHeight: '64px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                }}
              />
              Wind Management 2.0
            </span>
          </>
        )
      }
    >
      <Menu.Item key="wind2/plants">Wind Plants</Menu.Item>
      <Menu.Item key="wind2/subgroup">Wind Subgroup</Menu.Item>
      {piTagAccess && (
        <Menu.Item exact key="admin/pi-tag-wind">
          PI Tag
        </Menu.Item>
      )}
      <Menu.Item key="wind2/subgroup-formation">
        Wind Subgroup Formation
      </Menu.Item>
      {/* <Menu.Item key="wind2/contribcond">
            Wind Contribute Condition
          </Menu.Item> */}
      <Menu.Item key="wind2/user-access-right">
        Wind User Access Right
      </Menu.Item>
      <SubMenu title="Wind Support Data">
        <Menu.Item key="wind2/region">Wind NERC Region</Menu.Item>
        <Menu.Item key="wind2/entity">Wind Entity</Menu.Item>
        <Menu.Item key="wind2/scada">SCADA Manufacturer</Menu.Item>
        <Menu.Item key="wind2/turb-manf">Turbine Manufacturer</Menu.Item>
        <Menu.Item key="wind2/turb-type">Turbine Type</Menu.Item>
        <Menu.Item key="wind2/storage-manf">Storage Manufacturer</Menu.Item>
        <Menu.Item key="wind2/storage-inv-manf">
          Storage Inverter Manufacturer
        </Menu.Item>
        <Menu.Item key="wind2/storage-group">Storage Group</Menu.Item>
        {/* <Menu.Item key="wind2/contribcond">
              Wind Contribute Condition
            </Menu.Item> */}
        <Menu.Item key="wind2/causecode">Cause Code</Menu.Item>
        <Menu.Item key="wind2/errors">Wind Error Codes Managament</Menu.Item>
        <Menu.Item key="wind2/lockcheck">Wind Lock Management</Menu.Item>
      </SubMenu>
    </SubMenu>
  )

  const Wind20Menu = (hasWindPowerData ||
    hasWindPowerData20 ||
    hasPiAccess) && (
    <SubMenu
      title={
        !wind20MenuOnly ? (
          'Wind'
        ) : (
          <>
            {' '}
            <span>
              <Icon
                type="thunderbolt"
                style={{
                  height: '64px',
                  lineHeight: '64px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                }}
              />
              Wind
            </span>
          </>
        )
      }
    >
      {hasWindPowerData20 && (
        <Menu.ItemGroup>
          <Menu.Item key="wind2/wind-power-data-20">Wind Power 2.0</Menu.Item>
          {!hideWind2TurbinePerformance && (
            <Menu.Item key="wind2/wind-turbine-power-data-20">
              Wind Turbine Performance
            </Menu.Item>
          )}

          <Menu.Item key="wind2/wind2-level2-validation">
            Wind 2.0 Level 2 Validation
          </Menu.Item>
          {/* <Menu.SubMenu key="wind-op-2.0" title="Wind Operation 2.0" /> */}
          {wind2PiImportIntervals && (
            <Menu.Item key="wind2/wind2-pi-import-intervals">
              PI Import Intervals
            </Menu.Item>
          )}
          {hasWind2PIMissingData && (
            <Menu.Item key="wind2/wind2-pi-missing-data">
              Wind PI Missing Data
            </Menu.Item>
          )}

          {wind2FileCreation && (
            <Menu.Item key="wind2/wind2-file-creation">
              Wind NERC File Creation
            </Menu.Item>
          )}
          {wind2FileImport && (
            <Menu.Item key="wind2/wind2-file-import">
              Wind NERC File Import
            </Menu.Item>
          )}
          {wind2ImportCSV && (
            <Menu.Item key="wind2/wind-import-20">Wind File Import</Menu.Item>
          )}
          {hasWindReort20 && (
            <Menu.Item key="wind2/wind-report-20">Wind Report 2.0</Menu.Item>
          )}
          {hasWind2PIRowdata && (
            <Menu.SubMenu title="PI Row Data">
              <Menu.Item key="wind2/pi-row-10min-data">10Min Data</Menu.Item>
              <Menu.Item key="wind2/pi-row-hourly-data">Hourly Data</Menu.Item>
              <Menu.Item key="wind2/pi-row-daily-data">Daily Data</Menu.Item>
            </Menu.SubMenu>
          )}
        </Menu.ItemGroup>
      )}

      <Menu.ItemGroup>
        <Menu.Divider />
        {hasWindPowerData && (
          <Menu.Item key="wind/wind-power-data">Wind Power 1.0</Menu.Item>
        )}
        {hasPiAccess && (
          <Menu.SubMenu key="pi" title="Wind Operation 1.0">
            {hasPiMonthlySummaryAccess && (
              <Menu.Item key="pi-monthly-summary">PI Monthly Summary</Menu.Item>
            )}
            {hasPiImportDataAccess && (
              <Menu.Item key="pi-import">PI Data & Import</Menu.Item>
            )}
            {hasPiTagManagementAccess && (
              <Menu.Item key="pi-tag-manage">PI Tag Management</Menu.Item>
            )}
            <Menu.Item key="pi-log">PI Log</Menu.Item>
          </Menu.SubMenu>
        )}
      </Menu.ItemGroup>
    </SubMenu>
  )

  const ToolsMenu = (
    <SubMenu
      title={
        <span>
          <Icon
            type="tool"
            style={{
              height: '64px',
              lineHeight: '64px',
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          />
          Tools
        </span>
      }
      style={{ width: '120px', height: '64px', lineHeight: '64px' }}
    >
      {!hideCauseCodeLookUp && (
        <Menu.Item exact key="admin/causecodelookup">
          Cause Code Lookup
        </Menu.Item>
      )}
      <Menu.Item exact key="admin/userinfochange">
        User Info Change
      </Menu.Item>
      {UserMessageAccessTools && (
        <Menu.Item exact key="tools/adminmessage">
          Message From Administration
        </Menu.Item>
      )}
      {errorTraceUserScreen && (
        <Menu.Item exact key="errortraceuser">
          Error Stacktrace Log
        </Menu.Item>
      )}
      {!hideEventDurationCalculator && (
        <Menu.Item exact key="admin/eventduracalculator">
          Event Duration Calculator
        </Menu.Item>
      )}
      <Menu.Divider />
      <Menu.Item key="guide">Guide</Menu.Item>
    </SubMenu>
  )

  const LogoutMenu = (
    <SubMenu
      title={
        <Icon
          type="user"
          style={{
            height: '64px',
            lineHeight: '64px',
            fontSize: '20px',
            fontWeight: 'bold',
          }}
        />
      }
      style={{
        width: '50px',
        height: '64px',
        lineHeight: '64px',
        marginRight: '50px',
      }}
    >
      <Menu.Item disabled>
        <div style={{ color: 'white' }}>@{userInfo.userName}</div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="versions">Versions</Menu.Item>
      <Menu.Divider />
      <Menu.Item key="/">
        <a
          href="#"
          onClick={e => logout(e, apiTargetInfo)}
          style={{ marginRight: '20px', color: '#fff' }}
        >
          Log out
        </a>
      </Menu.Item>
    </SubMenu>
  )

  const onMenuSelect = path => {
    onSelect(path)
    setFilterDrawerVisible(false)
    setGridProps(emptyFilterObj)
    setFilterCondition([])
  }

  const isNENG_CLIENT = CLIENT === NE_NEW_ENGLAND

  if (isNENG_CLIENT)
    return (
      <NeISOMenu
        onSelect={onMenuSelect}
        menuTheme={menuTheme}
        currentPath={currentPath}
        envConfig={envConfig}
        actionPermits={actionPermits}
        userInfo={userInfo}
        logout={logout}
        // logout={e => logout(e, apiTargetInfo)}
        apiTargetInfo={apiTargetInfo}
      />
    )

  const isNYISO_CLIENT = CLIENT === NYISO_CLIENT

  if (isNYISO_CLIENT)
    return (
      <NYISOMenu
        onSelect={onSelect}
        menuTheme={menuTheme}
        currentPath={currentPath}
        envConfig={envConfig}
        actionPermits={actionPermits}
        userInfo={userInfo}
        logout={logout}
        // logout={e => logout(e, apiTargetInfo)}
        apiTargetInfo={apiTargetInfo}
      />
    )

  if (solarMenuOnly || wind20MenuOnly) {
    return (
      <Menu
        mode="horizontal"
        onSelect={onMenuSelect}
        theme={menuTheme}
        selectedKeys={[currentPath]}
        style={{ height: '40px', width: '100%', display: 'flex' }}
      >
        {hasAdminPermission && (
          <SubMenu
            key="secaccessadmin"
            title={
              <span>
                <Icon
                  type="security-scan"
                  style={{
                    height: '64px',
                    lineHeight: '64px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  }}
                />
                Security Access
              </span>
            }
          >
            <Menu.Item exact key="admin/role">
              Roles
            </Menu.Item>
            <Menu.Item exact key="admin/users">
              Users
            </Menu.Item>
            <Menu.Item exact key="admin/system-configuration">
              System Configuration
            </Menu.Item>
            {hasSchedulerPermission && (
              <Menu.Item exact key="admin/scheduler">
                Scheduled Jobs
              </Menu.Item>
            )}
            {hasWebServiceAccessPermission && (
              <Menu.Item exact key="admin/webserviceaccess">
                Web Service Access
              </Menu.Item>
            )}
            {hasWebServiceAccessPermission && (
              <Menu.Item exact key="admin/webserviceaccesslog">
                Web Service Access Log
              </Menu.Item>
            )}
          </SubMenu>
        )}
        {SolarAdminMenu}
        {Wind20AdminMenu}
        {SolarMenu}
        {Wind20Menu}
        {ToolsMenu}
        <Filler />
        {LogoutMenu}
      </Menu>
    )
  }

  return (
    <Menu
      mode="horizontal"
      onSelect={onMenuSelect}
      theme={menuTheme}
      selectedKeys={[currentPath]}
      style={{ height: '40px', width: '100%', display: 'flex' }}
    >
      {hasAdminPermission && (
        <SubMenu
          key="admin"
          title={
            <span>
              <Icon
                type="user-add"
                style={{ fontSize: '20px', fontWeight: 'bold' }}
              />
              <span>Administration</span>
            </span>
          }
          style={{
            height: '64px',
            lineHeight: '64px',
            width:
              wind20AdminScreenAccess ||
              solarAdminScreenAccess ||
              hasNYISOSupportDataPermission
                ? '190px'
                : '150px',
          }}
        >
          <SubMenu key="secaccessadmin" title="Security Access">
            <Menu.Item exact key="admin/role">
              Roles
            </Menu.Item>
            <Menu.Item exact key="admin/users">
              Users
            </Menu.Item>
            {CLIENT === PJM_CLIENT && (
              <Menu.Item exact key="admin/gads-acctmanager">
                Gads Account Manager
              </Menu.Item>
            )}
            {CLIENT === APS_CLIENT && (
              <Menu.Item exact key="admin/ad-mapping">
                AD Mapping
              </Menu.Item>
            )}
            {CLIENT === NE_NEW_ENGLAND && [
              <Menu.Item exact key="admin/iso-ne-users">
                ISO-NE Users
              </Menu.Item>,
              <Menu.Item exact key="admin/iso-ne-users-mapping">
                ISO-NE Users Mapping
              </Menu.Item>,
            ]}
            {CLIENT === MISO_CLIENT && [
              <Menu.Item exact key="admin/miso-company-users-mapping">
                Company - User Mapping
              </Menu.Item>,
              <Menu.Item exact key="admin/miso-users-mapping">
                MISO User Mapping
              </Menu.Item>,

              <Menu.Item exact key="admin/miso-users">
                MISO Auto User Data
              </Menu.Item>,
            ]}
          </SubMenu>
          <SubMenu title="Unit Configuration">
            <Menu.Item exact key="admin/company">
              Company
            </Menu.Item>
            <Menu.Item exact key="admin/global-unit-reassignment">
              Global Unit Re-Assignment
            </Menu.Item>
            <Menu.Item exact key="admin/eventypes">
              Event Type
            </Menu.Item>
            <Menu.Item exact key="admin/ownership-access">
              Ownership Access
            </Menu.Item>
            {!hidePercentOwnership && (
              <Menu.Item exact key="admin/percent-ownership">
                Percent Ownership
              </Menu.Item>
            )}
            {showOaPnodeZoneScreen && (
              <Menu.Item exact key="admin/pnode-emkt-mgmt">
                Pnode And Emkt Id Management
              </Menu.Item>
            )}
            <Menu.Item exact key="admin/station">
              Station
            </Menu.Item>
            <Menu.Item exact key="admin/unit">
              Units
            </Menu.Item>
            <Menu.Item exact key="admin/unit-group">
              Unit Groups
            </Menu.Item>
            <Menu.Item exact key="admin/utility-operator">
              Utility/Operator
            </Menu.Item>
            <Menu.Item exact key="admin/unit-type">
              Unit Type Management
            </Menu.Item>
            {riverSystemUnit && (
              <Menu.Item exact key="admin/river-system-unit">
                River System Unit
              </Menu.Item>
            )}
            {riverSystemRegion && (
              <Menu.Item exact key="admin/river-system-region">
                Region River System
              </Menu.Item>
            )}
            {showUnitBlock && (
              <Menu.Item exact key="admin/unit-block">
                Unit Block Management
              </Menu.Item>
            )}
            {CLIENT === TOTALENGERY_CLIENT && (
              <Menu.Item exact key="admin/total-ercot-mapping">
                ERCOT Mapping
              </Menu.Item>
            )}
            {CLIENT === COOP_CLIENT && (
              <Menu.Item exact key="admin/coop-miso-mapping">
                MISO Mapping
              </Menu.Item>
            )}
            {CLIENT === BEPC_CLIENT && (
              <Menu.Item exact key="admin/bepc-spp-mapping">
                SPP Mapping
              </Menu.Item>
            )}
          </SubMenu>
          <SubMenu title="Lock Management">
            {CLIENT !== PJM_CLIENT && CLIENT !== MISO_CLIENT && (
              <Menu.Item exact key="admin/holiday-mgmt">
                Holiday Management
              </Menu.Item>
            )}
            <Menu.Item exact key="admin/monthlylock">
              Monthly Lock Management
            </Menu.Item>
            <Menu.Item exact key="admin/unitlock">
              Unit Lock Release
            </Menu.Item>
            {verificationLock && (
              <Menu.Item key="verification-lock">Verification Lock</Menu.Item>
            )}
          </SubMenu>
          <SubMenu title="Configuration">
            <Menu.Item exact key="admin/amp-code-mgmt">
              Amplification Code Management
            </Menu.Item>
            {hasAccesPermits({
              authGodMode: envConfig.authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.TALEN_ADDITIONAL_EVENT_TAGS],
            }) && (
              <Menu.Item exact key="admin/card97-ext-spec">
                Additional Event Tags
              </Menu.Item>
            )}
            {hasAccesPermits({
              authGodMode: envConfig.authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.TALEN_ADDITIONAL_MONTHLY_TAGS],
            }) && (
              <Menu.Item exact key="admin/card95-ext-spec">
                Additional Monthly Tags
              </Menu.Item>
            )}
            <Menu.Item exact key="admin/cause-code-mgmt">
              Cause Code Management
            </Menu.Item>
            {ContribConditionView && (
              <Menu.Item exact key="admin/contrib-cond">
                Contributing Condition
              </Menu.Item>
            )}
            <Menu.Item exact key="admin/gads-error-mgmt">
              Error Management
            </Menu.Item>
            <Menu.Item exact key="admin/esuite-management">
              eSuite Management
            </Menu.Item>
            <Menu.Item exact key="admin/fail-code-mgmt">
              Fail Code Management
            </Menu.Item>
            <Menu.Item exact key="admin/fuel-code-mgmt">
              Fuel Code Management
            </Menu.Item>
            {melCausecode && (
              <Menu.Item exact key="admin/mel-causecode">
                Mel Cause Code
              </Menu.Item>
            )}
            {melComponent && (
              <Menu.Item exact key="admin/mel-component">
                Mel Component
              </Menu.Item>
            )}
            {profitcost && (
              <Menu.Item exact key="admin/profit-cost">
                Profit/Cost
              </Menu.Item>
            )}

            {nrgEventReportSpec && (
              <Menu.Item exact key="admin/event-report-spec">
                Event Report Scheduler
              </Menu.Item>
            )}
            {(MessageCategoryAccess ||
              UserMessageAccess ||
              UserMessageCategoryAccess) && (
              <SubMenu key="message" title="Message">
                {UserMessageCategoryAccess && (
                  <Menu.Item exact key="admin/user-message-category">
                    User Message Category
                  </Menu.Item>
                )}
                {MessageCategoryAccess && (
                  <Menu.Item exact key="admin/message-category">
                    Message Category
                  </Menu.Item>
                )}
                {UserMessageAccess && (
                  <Menu.Item exact key="admin/user-message">
                    User Message
                  </Menu.Item>
                )}
              </SubMenu>
            )}
            {!hideNercCapacity && (
              <Menu.Item exact key="admin/nerc-capacity">
                NERC Capacity
              </Menu.Item>
            )}
            {!hideNercGroup && (
              <Menu.Item exact key="admin/nercgroup">
                NERC Group
              </Menu.Item>
            )}
            {showNercClassAvgEford && (
              <Menu.Item exact key="admin/nercclassavgeford">
                NERC Class Avg. EFORD
              </Menu.Item>
            )}
            {hasAccesPermits({
              authGodMode: envConfig.authGodMode,
              actionPermits,
              eventActions: [
                ScreenPermissions.TALEN_NEISO_FILE_CREATION,
                ScreenPermissions.CHANGE_PERMISSIONS,
              ],
              matchAny: false,
            }) && (
              <Menu.Item exact key="admin/neiso-file-creation">
                NEISO File Creation
              </Menu.Item>
            )}
            {hasAccesPermits({
              authGodMode: envConfig.authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.TALEN_NYISO_FILE_CREATION],
            }) && (
              <Menu.Item exact key="admin/nyiso-file-creation">
                NYISO File Creation
              </Menu.Item>
            )}
            {nyisoderateGroup && (
              <Menu.Item exact key="admin/nyisoderategroup">
                NYISO Derates Group
              </Menu.Item>
            )}
            {apsPiWs && (
              <Menu.Item exact key="admin/pi-entity">
                PI Entity
              </Menu.Item>
            )}
            {(CLIENT === KINDLE_CLIENT ||
              CLIENT === EAST_GEN_CLIENT ||
              CLIENT === NRG_CLIENT ||
              hasAdminPeackDefinitation) && (
              <Menu.Item exact key="admin/peak-definition">
                Peak Definition
              </Menu.Item>
            )}

            {hasAdminPeackDefinitationHoliday && (
              <Menu.Item key="pjm-holiday">Peak Avail. Holiday</Menu.Item>
            )}
            {/* {piTagAccess && (
              <Menu.Item exact key="admin/pi-tag">
                PI Tag
              </Menu.Item>
            )} */}
            <Menu.Item exact key="admin/process-log">
              Process Log
            </Menu.Item>
            <Menu.Item exact key="admin/system-component-mgmt">
              System/Component Management
            </Menu.Item>
            {universalId && (
              <Menu.Item exact key="admin/universal-id">
                Universal ID
              </Menu.Item>
            )}
            <Menu.Item exact key="admin/system-configuration">
              System Configuration
            </Menu.Item>
            {srpSystemCodeManagementAccess && (
              <Menu.Item exact key="admin/systemcode">
                System Code Management
              </Menu.Item>
            )}

            {unitExtensionAccess && (
              <Menu.Item exact key="admin/unit-extension">
                Unit Extension
              </Menu.Item>
            )}

            {unitPerformanceGroup && (
              <Menu.Item exact key="admin/unit-perf-group">
                Unit Performance Group
              </Menu.Item>
            )}
            {hasWebServiceAccessPermission && (
              <Menu.Item exact key="admin/webserviceaccess">
                Web Service Access
              </Menu.Item>
            )}
            {hasWebServiceAccessPermission && (
              <Menu.Item exact key="admin/webserviceaccesslog">
                Web Service Access Log
              </Menu.Item>
            )}
          </SubMenu>
          {aepACAPSPPReport && (
            <SubMenu
              title="SPP ACAP Report Management"
              key="spp-aca-report-mgmt"
            >
              <Menu.Item key="acap/unittype">Unit Classifications</Menu.Item>
              <Menu.Item key="acap/units">Report Units</Menu.Item>
              <Menu.Item key="acap/verf-cap">Verified Capability</Menu.Item>
              <Menu.Item key="acap/parameter">Parameters</Menu.Item>
              <Menu.Item key="acap/cl-avg-stat">
                Class Average Statistics
              </Menu.Item>
              <Menu.Item key="acap/causecode">Non-OMC Cause Codes</Menu.Item>
              <Menu.Item key="acap/seasons">Seasons</Menu.Item>
              <Menu.Item key="acap/anplh">
                Adjusted Net Peak Load Hours (ANPLH)
              </Menu.Item>
            </SubMenu>
          )}
          {hasNYISOSupportDataPermission && (
            <SubMenu title="NYISO Support Data">
              {hasNYISOIIFOPermission && (
                <Menu.Item exact key="admin/iifo-outage">
                  IIFO Outage
                </Menu.Item>
              )}
              {hasNYISOPLWPermission && (
                <Menu.Item exact key="admin/iifo-plw">
                  Peak Load Window
                </Menu.Item>
              )}
              {hasNYISOMarsParameterPermission && (
                <Menu.Item exact key="admin/mars-report-param">
                  MARS Report Parameters
                </Menu.Item>
              )}
            </SubMenu>
          )}
          {hasWsInterfaceMenu && (
            <SubMenu title="WS Interface Import">
              {wsGenerationMW && (
                <Menu.Item exact key="admin/ws-generationmw">
                  Generation MW
                </Menu.Item>
              )}
              {wsFuelCost && (
                <Menu.Item exact key="admin/ws-fuelcost">
                  Fuel Cost
                </Menu.Item>
              )}
              {wsMarketPrice && (
                <Menu.Item exact key="admin/ws-marketprice">
                  Market Price
                </Menu.Item>
              )}
              {wsBreakerData && (
                <Menu.Item exact key="admin/ws-breakerdata">
                  Breaker Data
                </Menu.Item>
              )}
            </SubMenu>
          )}
          {windAdminScreenAccess && (
            <SubMenu title="Wind Management ">
              <Menu.Item exact key="wind/wind-inactive">
                Wind Inactive
              </Menu.Item>
              <Menu.Item exact key="wind/wind-subgroup-access">
                Wind Subgroup Access Right
              </Menu.Item>
              <Menu.Item exact key="wind/wind-plant">
                Wind Plant
              </Menu.Item>
              <Menu.Item exact key="wind/wind-subgroup">
                Wind Subgroup
              </Menu.Item>
              <Menu.Item exact key="wind/wind-utility-operator">
                Wind Utility Operator
              </Menu.Item>
              <Menu.Item exact key="wind/wind-error">
                Wind Error Management
              </Menu.Item>
            </SubMenu>
          )}

          {Wind20AdminMenu}

          {SolarAdminMenu}

          {hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.PROCESS_DATA_WITH_FILE_UPLOAD],
            matchAny: true,
          }) && (
            <Menu.Item key="admin/switchboard-import">
              Switchboard Import
            </Menu.Item>
          )}
          {OperatingData && (
            <Menu.Item exact key="admin/operatingdata">
              Report Operating Data
            </Menu.Item>
          )}
          {CLIENT === PJM_CLIENT && (
            <PjmAdminMenu
              onSelect={onSelect}
              theme={menuTheme}
              selectedKeys={[currentPath]}
            />
          )}
          {CLIENT === PJM_CLIENT && (
            <PjmAdminOutageMenu
              onSelect={onSelect}
              theme={menuTheme}
              selectedKeys={[currentPath]}
            />
          )}
          {misoAdminMenu && (
            <Menu.SubMenu key="misoadmin" title="Test Verification">
              {misoAdminTestDuration && (
                <Menu.Item exact key="admin/veriftestsche">
                  Verification Test Schedule
                </Menu.Item>
              )}
              {misoAdminTestDefault && (
                <Menu.Item exact key="admin/veriftestdefault">
                  Verification Test CLASS XEFORD
                </Menu.Item>
              )}
              {misoAdminVerificationSeason && (
                <Menu.Item exact key="admin/verifseason">
                  Verification Season
                </Menu.Item>
              )}
            </Menu.SubMenu>
          )}
          {hasSchedulerPermission && (
            <Menu.Item exact key="admin/scheduler">
              Scheduled Jobs
            </Menu.Item>
          )}
          {errorTraceAdminScreen && (
            <Menu.Item exact key="admin/errortraceadmin">
              Error Stacktrace Log
            </Menu.Item>
          )}
        </SubMenu>
      )}
      <SubMenu
        title={
          <span>
            <Icon
              type="link"
              style={{ fontSize: '20px', fontWeight: 'bold' }}
            />
            <span>Operation Data</span>
          </span>
        }
        style={{ height: '64px', lineHeight: '64px', width: '150px' }}
      >
        {(eventHydro || processHydro) && (
          <SubMenu
            title={
              renameHydroToBreakerEvent ? 'Breaker Events' : 'Hydro Events'
            }
          >
            {eventHydro && (
              <Menu.Item key="breaker-events">
                {renameHydroToBreakerEvent ? 'Breaker Events' : 'Hydro Events'}
              </Menu.Item>
            )}
            {processHydro && (
              <Menu.Item key="breaker-process">
                {renameHydroToBreakerEvent
                  ? 'Breaker Event Process'
                  : 'Hydro Event Process'}
              </Menu.Item>
            )}
          </SubMenu>
        )}

        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.DAILY_OPERATION_VIEW],
            matchAny: true,
          })) && <Menu.Item key="dailyview">Daily Operation View</Menu.Item>}

        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.MONTHLY_OPERATION_VIEW],
            matchAny: true,
          })) && (
          <Menu.Item key="monthlyview">Monthly Operation View</Menu.Item>
        )}
        {hasMonthlyPerfDataPermission && (
          <Menu.Item key="monthlypefdata">Monthly Performance Data</Menu.Item>
        )}
        {(marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
          <SubMenu title="Margin Analysis">
            {marginAnalysisAdminPermission && (
              <Menu.Item key="marginanalysis">Margin Analysis</Menu.Item>
            )}
            {marginAnalysisAdminPermission && (
              <Menu.Item key="marginanalysiswhatif">
                Margin Analysis What-If
              </Menu.Item>
            )}
            {marginAnalysisEventPlanning && (
              <Menu.Item key="marginanalysis-eventplanning">
                Event Planning
              </Menu.Item>
            )}
            {marginAnalysisSummary && (
              <Menu.Item key="marginanalysis-causecodesummary">
                Margin Analysis Summary
              </Menu.Item>
            )}
            {marginAnalysisTrueup && (
              <Menu.Item key="marginanalysis-trueup">CommOps True Up</Menu.Item>
            )}

            {marginAnalysisAdminPermission && (
              <Menu.Item key="marginanalysispnodezone">PNode Zone</Menu.Item>
            )}
            {marginAnalysisAdminPermission && (
              <Menu.Item key="marginanalysispeakdefinition">
                Peak Definition
              </Menu.Item>
            )}

            <MarginAnalysisMenu
              envConfig={envConfig}
              actionPermits={actionPermits}
              mode="horizontal"
              onSelect={onSelect}
              theme={menuTheme}
              selectedKeys={[currentPath]}
            />
            {marginAnalysisPJMImport && (
              <SubMenu title="PJM Import">
                <Menu.Item key="marginanalysis-dayaheadlmp">
                  Day Ahead LMP
                </Menu.Item>
                <Menu.Item key="marginanalysis-realtimelmp">
                  Real Time LMP
                </Menu.Item>
              </SubMenu>
            )}
          </SubMenu>
        )}

        {Wind20Menu}

        {SolarMenu}

        {(tpsDataAccess || tpsMappingAccess) && (
          <TPSMenu
            onSelect={onSelect}
            theme={menuTheme}
            selectedKeys={[currentPath]}
            CLIENT={CLIENT}
            dataAccess={tpsDataAccess}
            mappingAccess={tpsMappingAccess}
          />
        )}
        {hasTpsInterfaceMenu && (
          <SubMenu title="TPS Interface">
            {tpsUnitMappingAccess && (
              <Menu.Item key="tps-unit-mapping">Unit Mapping (TPS)</Menu.Item>
            )}
            {hasTpsInterfaceMenu && (
              <Menu.Item key="tps-file-log">TPS File Log</Menu.Item>
            )}
            {tpsMaDataImportAccess && (
              <Menu.Item key="tps-import-ma-data">
                Import MA Data (TPS)
              </Menu.Item>
            )}
          </SubMenu>
        )}
        {hasMisoInterfaceMenu && (
          <SubMenu title="MISO Interface">
            {misoUnitMappingAccess && (
              <Menu.Item key="miso-unit-mapping">Unit Mapping (MISO)</Menu.Item>
            )}
            {misoMaDataImportAccess && (
              <Menu.Item key="miso-import-ma-data">
                Import MA Data (MISO)
              </Menu.Item>
            )}
            <Menu.Item key="tps-file-log">MISO File Log</Menu.Item>
          </SubMenu>
        )}
        {pprAccess && <Menu.Item key="ppr">PPR</Menu.Item>}

        {ctInspection && (
          <Menu.SubMenu key="ct-inspection" title="CT Inspection">
            <Menu.Item key="ct-modal">Modal</Menu.Item>
            <Menu.Item key="ct-modal-unit">Modal Unit</Menu.Item>
            <Menu.Item key="ct-inspection-type">CT Inspection Type</Menu.Item>
            <Menu.Item key="ct-inspection-interval">
              CT Inspection Interval
            </Menu.Item>
            <Menu.Item key="ct-inspection-unit-comment">
              CT Inspection Unit Comment
            </Menu.Item>
            <Menu.Item key="ct-inspection-unit-override">
              CT Inspection Unit Override
            </Menu.Item>
          </Menu.SubMenu>
        )}
        {verificationMenu && (
          <Menu.SubMenu
            title={
              <span>
                <span>Verification Data</span>
              </span>
            }
          >
            {netCapacityVerificationImport && (
              <Menu.Item key="net-cap-verification-data-import">
                Net Capacity Verification Data Import
              </Menu.Item>
            )}
            {(netCapacityVerificationRead || netCapacityVerificationWrite) && (
              <Menu.Item key="net-cap-verification">
                Net Capacity Verification
              </Menu.Item>
            )}
            {netCapacityVerificationExport && (
              <Menu.Item key="net-cap-verification-data-export">
                Net Capacity Verification Data Export
              </Menu.Item>
            )}
            {VerificationHourlyMWH && (
              <Menu.Item key="verification-hourly-mwh">
                Verification Hourly MWH
              </Menu.Item>
            )}
          </Menu.SubMenu>
        )}
        {MisoVerificationTestData && (
          <Menu.SubMenu
            title={
              <span>
                <span>Verification Data</span>
              </span>
            }
          >
            {MisoNetCapacityVerificationImport && (
              <Menu.Item key="miso/net-cap-verification-data-import">
                Net Capacity Verification Data Import
              </Menu.Item>
            )}
            {(MisoVerificationTestData || MisoNetCapacityVerificationWrite) && (
              <Menu.Item key="miso/net-cap-verification">
                Net Capacity Verification
              </Menu.Item>
            )}
            {MisoNetCapacityVerificationExport && (
              <Menu.Item key="miso/net-cap-verification-data-export">
                Net Capacity Verification Data Export
              </Menu.Item>
            )}
            {MisoVerificationTestData && (
              <Menu.Item key="miso/net-cap-verification-summary">
                Net Capacity Verification Summary
              </Menu.Item>
            )}
            {MisoVerificationTestData && (
              <Menu.Item key="miso/net-cap-verification-hist">
                Historical Net Capacity Verification Data
              </Menu.Item>
            )}
            {MisoVerificationTestData && (
              <Menu.Item key="miso/net-cap-verification-hist-summ">
                Historical Net Capacity Verification Summary Data
              </Menu.Item>
            )}
          </Menu.SubMenu>
        )}

        {CLIENT === TALEN_CLIENT && hasTalenOutageAnalysisMenu && (
          <Menu.SubMenu
            key="Outage-analysis-admin"
            style={{ padding: '0px', margin: '0px' }}
            title={
              <span>
                {/* <Icon
                  type="control"
                  style={{
                    height: '64px',
                    lineHeight: '64px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  }}
                /> */}
                <span>Outage Analysis</span>
              </span>
            }
          >
            {hasOutageAnalysis && (
              <Menu.Item key="outage-analyzer">Outage Analyzer</Menu.Item>
            )}
            <Menu.Item key="marginanalysis-dayaheadlmp-talen">
              Day Ahead LMP
            </Menu.Item>
            <Menu.Item key="marginanalysis-realtimelmp-talen">
              Real Time LMP
            </Menu.Item>
            {hasBidOffer && (
              <Menu.Item key="oa-bid-offer-talen">Bid Offer</Menu.Item>
            )}
            {hasScheduleDetail && (
              <Menu.Item key="oa-schedule-details-talen">
                Schedule Details
              </Menu.Item>
            )}
            <Menu.Item exact key="admin/oa-peak-definition">
              Peak Definition
            </Menu.Item>
          </Menu.SubMenu>
        )}

        {CLIENT === PJM_CLIENT && hasOutageAnalysisMenu && (
          <Menu.SubMenu
            key="Outage-analysis-admin"
            style={{ padding: '0px', margin: '0px' }}
            title={
              <span>
                {/* <Icon
                  type="control"
                  style={{
                    height: '64px',
                    lineHeight: '64px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  }}
                /> */}
                <span>Outage Analysis</span>
              </span>
            }
          >
            {hasOutageAnalysis && (
              <Menu.Item key="outage-analyzer">Outage Analyzer</Menu.Item>
            )}
            {hasScheduleDetail && (
              <Menu.Item key="oa-schedule-details">Schedule Details</Menu.Item>
            )}
            {hasBidOffer && <Menu.Item key="oa-bid-offer">Bid Offer</Menu.Item>}
            {hasOpThreshold && (
              <Menu.Item key="op-rsv-threshold">Op. Rsv. Threshold </Menu.Item>
            )}
          </Menu.SubMenu>
        )}

        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.NERC_FILE_CREATION],
            matchAny: true,
          })) && (
          <Menu.Item key="nerc-file-creation-antd">
            NERC File Creation
          </Menu.Item>
        )}
        {hasAccesPermits({
          authGodMode: envConfig.authGodMode,
          actionPermits,
          eventActions: [ScreenPermissions.NEISO_FILE_CREATION],
          matchAny: false,
        }) && (
          <Menu.Item exact key="file/neiso-file-creation">
            NEISO File Creation
          </Menu.Item>
        )}

        {nonOutageSpill && (
          <Menu.Item key="non-outage-spill">Non Outage Spill</Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.PJM_FILE_CREATION],
            matchAny: true,
          })) && (
          <Menu.Item key="pjm-file-creation-antd">PJM File Creation</Menu.Item>
        )}

        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.NERC_CAPACITY_USER_ADMIN,
              ScreenPermissions.NERC_CAPACITY_USER,
            ],
            matchAny: true,
          })) && <Menu.Item key="user-nerc-capacity">NERC Capacity</Menu.Item>}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.CARDDATA_IMPORT],
            matchAny: true,
          })) && <Menu.Item key="data-import-antd"> Data Import</Menu.Item>}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.VIEW_GENERATION,
              ScreenPermissions.ADMIN_GENERATION,
              ScreenPermissions.VIEW_GENERATION_AUX,
              ScreenPermissions.ADMIN_GENERATION_AUX,
              ScreenPermissions.VIEW_GENERATION_BY_HOUR,
              ScreenPermissions.ADMIN_GENERATION_BY_HOUR,
              ScreenPermissions.VIEW_GENERATION_BY_HOUR_DOM,
              ScreenPermissions.ADMIN_GENERATION_BY_HOUR_DOM,
            ],
            matchAny: true,
          })) && <Menu.Item key="view-generation">Generation</Menu.Item>}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.DERATE_VIEW,
              ScreenPermissions.DERATE_PROCESS,
            ],
            matchAny: true,
          })) && <Menu.Item key="derate-view">Hourly Derate</Menu.Item>}
        {/* {(authGodMode ||
            hasAccesPermits({
              authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.DERATE_PROCESS],
              matchAny: true,
            })) && (
            <Menu.Item key="derate-process">Process Hourly Derate</Menu.Item>
          )} */}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.DERATE_CAUSECODE_VIEW,
              ScreenPermissions.DERATE_CAUSECODE_PROCESS,
            ],
            matchAny: true,
          })) && (
          <Menu.Item key="derate-causecode-view">
            Hourly Derate by Cause Code
          </Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.DERATE_PROCESS_NYISO],
            matchAny: true,
          })) && (
          <Menu.Item key="derate-process-nyiso">
            Process NYISO Derates
          </Menu.Item>
        )}
        {/* {(authGodMode ||
            hasAccesPermits({
              authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.DERATE_CAUSECODE_PROCESS],
              matchAny: true,
            })) && (
            <Menu.Item key="derate-causecode-process">
              Process Hourly Derate by Cause Code
            </Menu.Item>
          )} */}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.REQUEST_GENERATION_DATA],
            matchAny: true,
          })) && <Menu.Item key="request-generation">Request Data</Menu.Item>}

        {kindleMySqqlMenu && (
          <Menu.SubMenu key="kindle-mysql" title="Data Transfer">
            {kindleMySqqlDALmp && <Menu.Item key="ms-da-lmp">DA LMP</Menu.Item>}
            {kindleMySqqlRTLmp && <Menu.Item key="ms-rt-lmp">RT LMP</Menu.Item>}
            {kindleMySqqlGeneration && (
              <Menu.Item key="ms-generation">Generation</Menu.Item>
            )}
            {kindleMySqqlDaAward && (
              <Menu.Item key="ms-daaward">DA Ahead Award</Menu.Item>
            )}
            {kindleMySqqlFuel && <Menu.Item key="ms-fuel">Fuel</Menu.Item>}
            {(kindleMySqqlDALmp ||
              kindleMySqqlRTLmp ||
              kindleMySqqlGeneration ||
              kindleMySqqlDaAward ||
              kindleMySqqlFuel) && (
              <Menu.Item key="ms-data-log">Data Import Log</Menu.Item>
            )}
          </Menu.SubMenu>
        )}
        {hasAccesPermits({
          authGodMode: envConfig.authGodMode,
          actionPermits,
          eventActions: [ScreenPermissions.TALEN_ADDN_MONTHLY_TRACKING],
        }) && (
          <Menu.Item exact key="admin/card95-extension">
            Additional Monthly Tracking
          </Menu.Item>
        )}
        {hasAccesPermits({
          authGodMode: envConfig.authGodMode,
          actionPermits,
          eventActions: [ScreenPermissions.TALEN_PROCESS_ALL],
        }) && (
          <Menu.Item exact key="admin/monthly-error-log">
            Process All
          </Menu.Item>
        )}
      </SubMenu>

      {hasInterfaceMenu && (
        <SubMenu
          title={
            <span>
              <Icon
                type="container"
                style={{ fontSize: '20px', fontWeight: 'bold' }}
              />
              <span>Interface Data</span>
            </span>
          }
          style={{ height: '64px', lineHeight: '64px', width: '130px' }}
        >
          {hasInterfaceMW && <Menu.Item key="mw-import">MW Import</Menu.Item>}
          {hasInterfaceBreakerImport && (
            <Menu.Item key="breaker-import">Breaker Import</Menu.Item>
          )}
          {hasInterfaceCraneCreek && (
            <Menu.Item key="crane-creek-import">Crane Creek Import</Menu.Item>
          )}
          {hasInterfaceForwardImport && (
            <Menu.Item key="forward-import">Forward Import</Menu.Item>
          )}
          {hasInterfaceBSGF && (
            <Menu.Item key="bsgf-import">BSGF Import</Menu.Item>
          )}
          {hasInterfaceGHWP && (
            <Menu.Item key="ghwp-import">GHWP Import</Menu.Item>
          )}
          {hasInterfaceTurbinePoints && (
            <Menu.Item key="turbine-points">Turbine Points</Menu.Item>
          )}
          {hasInterfaceBSGFErrorCodeMap && (
            <Menu.Item key="bsgf-error-code-map">
              BSGF/GHWP Error Code Map
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {(authGodMode ||
        hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [
            ScreenPermissions.VALIDATION_RUNCHECK,
            ScreenPermissions.VALIDATION_LOG,
            ScreenPermissions.VALIDATION_MONTHLY,
            ScreenPermissions.VALIDATION_EVENT_PENDING,
            ScreenPermissions.VALIDATION_EVENT_PENDING_APPROVAL,
          ],
          matchAny: true,
        })) && (
        <SubMenu
          title={
            <span>
              <Icon
                type="bulb"
                style={{ fontSize: '20px', fontWeight: 'bold' }}
              />
              <span>Level 2 Validation</span>
            </span>
          }
          style={{ height: '64px', lineHeight: '64px', width: '170px' }}
        >
          <Menu.Item key="level-2-validation-tab">Validation</Menu.Item>
          <Menu.Item key="level-2-validation-status-antd">
            Validation Status
          </Menu.Item>
          {hasPerValidationMonthly && (
            <Menu.Item key="validation-monthly">Validation Monthly</Menu.Item>
          )}
          {hasPerValidationBlockLevel2 && (
            <Menu.Item key="validation-block-level-2">
              Block Level 2 Processing
            </Menu.Item>
          )}
          {eventPending && (
            <Menu.Item key="event-pending">Event Pending Approval</Menu.Item>
          )}
        </SubMenu>
      )}
      <SubMenu
        title={
          <span>
            <Icon
              type="credit-card"
              style={{ fontSize: '20px', fontWeight: 'bold' }}
            />
            <span>Card Data</span>
          </span>
        }
        style={{ width: '130px', height: '64px', lineHeight: '64px' }}
      >
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.CARD95_ADMIN,
              ScreenPermissions.CARD95_VIEWER,
            ],
            matchAny: true,
          })) && (
          <Menu.Item key="card95-performance-data-antd">
            Card95 - Performance Data
          </Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.CARD97_ADMIN,
              ScreenPermissions.CARD97_VIEWER,
            ],
            matchAny: true,
          })) && (
          <Menu.Item key="card97-event-data"> Card97 - Event Data</Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.CARD97_BREAKER_VERIFY,
              // ScreenPermissions.CARD97_ADMIN,
            ],
            matchAny: true,
          })) && (
          <Menu.Item key="card97-breaker-verify">
            Breaker & Event - Verification
          </Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.CARD97_FE_DART_EVENT_RECONCILIATION,
            ],
            matchAny: true,
          })) && (
          <Menu.Item key="pdart-edart-outage"> DART Reconciliation</Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.CARD97_CUSTOM],
            matchAny: true,
          })) && (
          <Menu.Item key="custom-card97-data"> Custom Card97 Data</Menu.Item>
        )}

        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.CARD97_EXCLUSION_EVENT_WRITE,
              ScreenPermissions.CARD97_EXCLUSION_EVENT_READ,
            ],
            matchAny: true,
          })) && (
          <Menu.Item key="card97-exclusion">
            Card97 - Excluded Event Data
          </Menu.Item>
        )}
        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.CARD97_DUKE_FOS_REFERENCE],
            matchAny: true,
          })) && (
          <Menu.Item key="card97-duke-fossil">
            Card97 - Duke Event Data
          </Menu.Item>
        )}

        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              ScreenPermissions.CARD99_ADMIN,
              ScreenPermissions.CARD99_VIEWER,
            ],
            matchAny: true,
          })) && (
          <Menu.Item key="card99-fuel-data-antd">Card99 - Fuel Data</Menu.Item>
        )}

        {(nrgCard95DataAnalyticsImport || nrgCard97DataAnalyticsImport) && (
          <Menu.SubMenu key="nrg-datanalytics" title="Data Analytics">
            {nrgCard95DataAnalyticsImport && (
              <Menu.Item key="card95-dataanalytics-import">
                Import Card95 Data
              </Menu.Item>
            )}
            {nrgCard97DataAnalyticsImport && (
              <Menu.Item key="card97-dataanalytics-import">
                Import Card97 Data
              </Menu.Item>
            )}
          </Menu.SubMenu>
        )}

        {(authGodMode ||
          hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [
              // ScreenPermissions.CARD_HISTORY_VIEWER,
              ScreenPermissions.CARD95_HISTORY_VIEWER,
              ScreenPermissions.CARD97_HISTORY_VIEWER,
              ScreenPermissions.CARD99_HISTORY_VIEWER,
            ],
            matchAny: true,
          })) && (
          <Menu.Item key="card-history-data-antd"> Card History Data</Menu.Item>
        )}
        {/* <Menu.Item key="card95-performance-data"> Card95 - Performance Data</Menu.Item>
         <Menu.Item key="card99-fuel-data">Card99 - Fuel Data</Menu.Item>
         <SubMenu title={'Data Modification History'}>
           <Menu.Item key="Card-History-Data-95"> Card95 Modification History</Menu.Item>
           <Menu.Item key="Card-History-Data-97"> Card97 Modification History</Menu.Item>
           <Menu.Item key="Card-History-Data-99"> Card99 Modification History</Menu.Item>
         </SubMenu> */}
      </SubMenu>

      {hasSwitchboardAccess && (
        <SubMenu
          title={
            <span>
              <Icon
                type="control"
                style={{
                  height: '64px',
                  lineHeight: '64px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                }}
              />
              <span>Switchboard</span>
            </span>
          }
          style={{ width: '130px', height: '64px', lineHeight: '64px' }}
        >
          <Menu.Item key="ons">ONS</Menu.Item>
          <Menu.Item key="mns">MNS</Menu.Item>
          <Menu.Item key="cns">CNS</Menu.Item>
          <Menu.Item key="rnp">RNP</Menu.Item>
          <Menu.Item key="hnp">HNP</Menu.Item>
          <Menu.Item key="bnp">BNP</Menu.Item>
          <Menu.Item key="switchboardlog">Switchboard Files</Menu.Item>
        </SubMenu>
      )}

      {nonHydroEvent && (
        <SubMenu
          title={
            <span>
              <Icon
                type="block"
                style={{
                  height: '64px',
                  lineHeight: '64px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                }}
              />
              <span>
                {CLIENT === BROOKFIELD_CLIENT
                  ? 'Hydro Breaker'
                  : 'Non-Hydro Events'}
              </span>
            </span>
          }
          style={{ width: '170px', height: '64px', lineHeight: '64px' }}
        >
          {(authGodMode ||
            hasAccesPermits({
              authGodMode,
              actionPermits,
              eventActions: [
                ScreenPermissions.NONHYDRO_VIEW,
                ScreenPermissions.NONHYDRO_ADD_DATA,
                ScreenPermissions.NONHYDRO_IMPORT,
              ],
              matchAny: true,
            })) && (
            <Menu.Item key="nonhydro-events">
              {CLIENT === BROOKFIELD_CLIENT ? 'Hydro Breaker Events' : 'Events'}
            </Menu.Item>
          )}
          {(authGodMode ||
            hasAccesPermits({
              authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.NONHYDRO_PROCESS],
              matchAny: true,
            })) && (
            <Menu.Item key="nonhydro-process">
              {CLIENT === BROOKFIELD_CLIENT
                ? 'Process Hydro Breaker Events'
                : 'Process Events'}
            </Menu.Item>
          )}
        </SubMenu>
      )}
      {(authGodMode ||
        hasAccesPermits({
          authGodMode,
          actionPermits,
          eventActions: [
            ScreenPermissions.REPORT_ACCESS,
            ScreenPermissions.REPORT_ADHOCK_ACCESS_PDF,
            ScreenPermissions.REPORT_ADHOCK_ACCESS_EXCEL,
            ScreenPermissions.REPORT_DASHBOARD_ACCESS,
            ScreenPermissions.WIND_ADHOC_MATRIX_REPORT,
            ScreenPermissions.REPORT_ADHOC_PROCESS,
            ScreenPermissions.REPORT_PERFORMANCE_MEASURES_ADMIN,
            ScreenPermissions.REPORT_PERFORMANCE_MEASURES_VIEW,
            ScreenPermissions.EVENT_DASHBOARD,
            ScreenPermissions.WIND_REPORT_20,
          ],
          matchAny: true,
        })) && (
        <SubMenu
          title={
            <span>
              <Icon
                type="audit"
                style={{
                  height: '64px',
                  lineHeight: '64px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                }}
              />
              <span>Reports</span>
            </span>
          }
          style={{ width: '100px', height: '64px', lineHeight: '64px' }}
        >
          {(authGodMode ||
            hasAccesPermits({
              authGodMode,
              actionPermits,
              eventActions: [
                ScreenPermissions.REPORT_ADHOCK_ACCESS_PDF,
                ScreenPermissions.REPORT_ADHOCK_ACCESS_EXCEL,
              ],
              matchAny: true,
            })) && <Menu.Item key="adhoc-report">Ad Hoc Report</Menu.Item>}
          {(authGodMode ||
            hasAccesPermits({
              authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.REPORT_ADHOC_PROCESS],
              matchAny: true,
            })) && (
            <Menu.Item key="adhoc-report-process">Ad Hoc DB Process</Menu.Item>
          )}
          {hasWindAdhoc && (
            <Menu.Item key="windadhoc">Wind Ad Hoc Report</Menu.Item>
          )}
          {hasAccesPermits({
            authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.REPORT_DASHBOARD_ACCESS],
            matchAny: true,
          }) && (
            <Menu.Item
              key="report-dashboard"
              style={{ height: '64px', lineHeight: '64px' }}
            >
              <span> Report Dashboard</span>
            </Menu.Item>
          )}

          {(authGodMode ||
            hasAccesPermits({
              authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.REPORT_ACCESS],
              matchAny: true,
            })) && [
            <Menu.Item key="reportantd">Reports</Menu.Item>,
            <Menu.Item key="completedreports">Completed Reports</Menu.Item>,
          ]}
          {hasEventDashboardReport && (
            <Menu.Item key="event-dashboard-report">Event Dashboard</Menu.Item>
          )}
          {hasSRPEventDashboardReport && (
            <Menu.Item key="srp-event-dashboard-report">
              SRP Event Dashboard
            </Menu.Item>
          )}
          {performanceOveride && (
            <Menu.Item key="performance-override">
              Performance Measures Override
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {hasGraphAccess && (
        <SubMenu
          key="analytics"
          title={
            <span>
              <Icon
                type="radar-chart"
                style={{ fontSize: '20px', fontWeight: 'bold' }}
              />
              <span>Analytics</span>
            </span>
          }
          style={{ height: '64px', lineHeight: '64px', width: '120px' }}
        >
          {hasGraphMWAndCommercialAccess && [
            <SubMenu key="BasicBar" title="Basic Bar">
              {kpiSpec.map(({ id, display }) => (
                <Menu.Item exact={'bar/' + id} key={'bar/' + id}>
                  {display}
                </Menu.Item>
              ))}
            </SubMenu>,
            <Menu.Item exact key="contrib">
              Contribution Break-Down
            </Menu.Item>,
            <Menu.Item exact key="scatter">
              Scatter Charts
            </Menu.Item>,
            <Menu.Item exact key="trend">
              Trends
            </Menu.Item>,
          ]}

          {hasGraphForecastsAccess && (
            <SubMenu key="forecast" title="Forecasts">
              {foreCastMetrics.map(({ id, display }) => (
                <Menu.Item
                  key={'time-series-foecast/' + id}
                  exact={`/time-series-foecast/${id}`}
                >
                  {display}
                </Menu.Item>
              ))}
            </SubMenu>
          )}
          {/* <Menu.Item to="/bill-diff" as={Link}>
          Bill Diff Report
          </Menu.Item> */}

          {/* <Menu.Item to="/pattern-analysis/summary" as={Link}>
          Data Pattern Analysis
        </Menu.Item>

        <Dropdown text="Heatmaps" pointing className="link item">
          <Dropdown.Menu>
            <Dropdown.Item to={'/heatmaps/weekly-lost-opp-revenue'} as={Link}>
              Lost Opportunity Revenue
            </Dropdown.Item>
            <Dropdown.Item to={'/heatmaps/pnl-weekly'} as={Link}>
              PNL weekly analysis
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}

          {
            // <Dropdown text="Contribution Break-Down" pointing className="link item">
            // <Dropdown.Menu>
            // {contribKeys.map(kpi => (
            //   <Dropdown.Item key={kpi} to={`/contrib/${kpi}`} as={Link}>
            //   {fromNullable(displayMap[kpi]).getOrElse(kpi)}
            //   </Dropdown.Item>
            // ))}
            // {caContribKeys.map(kpi => (
            //   <Dropdown.Item key={kpi} to={`/ca-contrib/${kpi}`} as={Link}>
            //   {fromNullable(displayMap[kpi]).getOrElse(kpi)}
            //   </Dropdown.Item>
            // ))}
            // </Dropdown.Menu>
            // </Dropdown>
          }
          {
            // <Menu.Item name="Goal" to="/goal" as={Link} />
          }
        </SubMenu>
      )}

      {ToolsMenu}

      <Filler />
      {LogoutMenu}
    </Menu>
  )
}

class Nav extends React.Component {
  menuSelected = ({ key }) => {
    //
    const { history } = this.props
    const location = { pathname: `/${key}` }
    history.push(location)
  }

  render() {
    const { theme = { mode: 'dark' }, apiTargetInfo } = this.props
    const { kpiSpec, contribKeys, caContribKeys /* trendGraphs */ } = this.props
    const menuTheme = theme.mode
    const currentPath = this.props.location.pathname.substring(1) || '/init'

    return (
      <Switch>
        <Route
          render={() => (
            <div
              style={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: '150px auto',
                marginLeft: '15px',
              }}
            >
              {/* <div> */}
              <div style={{ fontSize: '28px', color: 'white' }}>
                <Icon
                  type="appstore"
                  style={{ marginRight: '5px', fontSize: '25px' }}
                />
                <span style={{ marginRight: '25px' }}>PGADS</span>
              </div>
              {/* <span>
                    {this.props.userInfo.firstName
                      ? this.props.userInfo.firstName
                      : this.props.userInfo.userName}{' '}
                  </span>
                </div> */}
              <FilterContext>
                {({ setDrawerVisible, setGridProps, setFilterCondition }) => (
                  <UserNav
                    onSelect={this.menuSelected}
                    menuTheme={menuTheme}
                    currentPath={currentPath}
                    actionPermits={this.props.actionPermits}
                    envConfig={this.props.envConfig}
                    userInfo={this.props.userInfo}
                    kpiSpec={kpiSpec}
                    contribKeys={contribKeys}
                    caContribKeys={caContribKeys}
                    apiTargetInfo={apiTargetInfo}
                    history={this.props.history}
                    setFilterDrawerVisible={setDrawerVisible}
                    setGridProps={setGridProps}
                    setFilterCondition={setFilterCondition}
                  />
                )}
              </FilterContext>
            </div>
          )}
        />
      </Switch>

      // </Sider>
    )
  }
}

const mapStateToProps = state => ({
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  userInfo: getUserInfo(state),
  kpiSpec: getKpiSpec(state),
  contribKeys: getContribKeys(state),
  caContribKeys: getCAContribKeys(state),
  apiTargetInfo: getApiTargetInfo(state),
})
export default withRouter(connect(mapStateToProps)(Nav))
// export default withRouter(Nav)
